export default __webpack_public_path__ + "static/media/P200-Tip-Solution-Blue.c31fa7b9.svg";